export const hasSnipcart = () =>
    typeof window !== "undefined" && window.Snipcart;